import { FC, MutableRefObject, useEffect, useRef } from 'react';
import { Text } from '@bpba/ui-components';
import { ProductConfig } from './ProductConfig';
import { OutlineVStack } from '../shared/OutlineVStack';

type Props = {
  show: boolean;
  productConfig?: ProductConfig;
};

export const MensajeExitoso: FC<Props> = ({ show, productConfig }) => {
  const ref: MutableRefObject<HTMLDivElement | null> = useRef(null);

  /** Accesibilidad: se hace foco en este componente
   * cuando es cargado por primera vez.
   */
  useEffect(() => {
    if (show) {
      ref?.current?.focus();
    }
  }, [show]);

  if (!show || (!productConfig?.exitoTitulo && !productConfig?.exitoSubtitulo)) return <></>;

  return (
    <OutlineVStack ref={ref} tabIndex={0} outline="none">
      <Text color="primary.0" fontSize={1} fontWeight={700} paddingTop="32px" paddingBottom="8px">
        {productConfig.exitoTitulo}
      </Text>
      <Text color="primary.0" fontWeight={500} paddingBottom={16}>
        {productConfig.exitoSubtitulo}
      </Text>
    </OutlineVStack>
  );
};
